const generateData = (rows, query) => {
  const newData = rows.map((row, key) => ({
    num: query?.page * query?.pageSize + key + 1,
    docId: row.cols[1], // 1417 شماره سند
    date: row.cols[2], // تاریخ
    time: row.cols[3], // زمان
    inventory: row.cols[5], // موجودی
    accountBalance: row.cols[8], // مانده
    priceWithdraw: row.cols[7], // مبلغ برداشت
    priceDeposit: row.cols[6], // مبلغ واریز
    description: row.cols[4], // شرح سند
    documentItemId: row.cols[0], // documentItemId
  }));

  return newData;
};

export default generateData;
